import { NotificationsView } from '../notifications/NotificationsView.tsx'

export const ProfileNotifications = () => {
  return <NotificationsView withBack />
}
